import React from "react";
import ContentPage, { Block } from "../components/ContentPage";

export default function PrivacyPage() {
  return (
    <ContentPage title="Privacybeleid" lead={null} ctaLabel={null}>
      <Block title="Privacy Policy">
        <p>
          This privacy policy applies to the Suriwebwinkel app (hereby referred
          to as &quot;Application&quot;) for mobile devices that was created by
          Shiva Bhaggan (hereby referred to as &quot;Service Provider&quot;) as
          a Free service. This service is intended for use &quot;AS IS&quot;.
        </p>
      </Block>
      <Block title="Information Collection and Use">
        <p>
          The Application collects information when you download and use it.
          This information may include:
        </p>
        <ul>
          <li>Your device&apos;s Internet Protocol address (e.g. IP address)</li>
          <li>
            The pages of the Application that you visit, the time and date of
            your visit, the time spent on those pages
          </li>
          <li>The time spent on the Application</li>
          <li>The operating system you use on your mobile device</li>
        </ul>
        <p>
          The Application does not gather precise information about the location
          of your mobile device.
        </p>
      </Block>
      <Block title="Contact Us">
        <p>
          If you have any questions regarding privacy, please contact the
          Service Provider via email at{" "}
          <a href="mailto:shivabhaggan@gmail.com">shivabhaggan@gmail.com</a> or{" "}
          <a href="mailto:suriweb@suriwebwinkel.nl">suriweb@suriwebwinkel.nl</a>
          .
        </p>
      </Block>
    </ContentPage>
  );
}
